// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + ({"2348":"chat","2443":"about"}[chunkId] || chunkId) + "." + {"2348":"e3066919","2443":"293e576e","6780":"771d184b"}[chunkId] + ".css";
};